import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: theme.spacing(3),
    },
  },
  formGroup: {
    flex: 1,
    minWidth: 0,
  },
  formSpacing: {
    marginTop: theme.spacing(4),
  },
}))

export default useStyles
